function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M363.539 137.082L50.6185 204.223L143.386 636.578L456.307 569.436L363.539 137.082Z",
  fill: "#E0E0E0"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M359.823 145.526L57.4786 210.398L147.111 628.139L449.455 563.266L359.823 145.526Z",
  fill: "url(#paint0_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M356.63 149.427L61.9833 212.647L149.635 621.158L444.282 557.937L356.63 149.427Z",
  fill: "#FAFAFA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M278.979 147.563L132.808 178.926L140.405 214.334L286.576 182.971L278.979 147.563Z",
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M198.504 128.462C187.172 130.9 180.002 142.293 182.495 153.908C184.988 165.522 196.187 172.976 207.497 170.538C218.807 168.1 225.999 156.707 223.506 145.092C221.013 133.478 209.836 126.024 198.504 128.462ZM205.615 161.678C203.22 162.25 200.709 162.095 198.402 161.232C196.096 160.37 194.098 158.839 192.663 156.835C191.228 154.831 190.422 152.445 190.346 149.98C190.271 147.515 190.93 145.084 192.239 142.996C193.549 140.907 195.449 139.257 197.699 138.254C199.948 137.252 202.445 136.943 204.87 137.367C207.296 137.791 209.54 138.929 211.318 140.635C213.095 142.341 214.325 144.539 214.851 146.948C215.214 148.523 215.263 150.154 214.995 151.748C214.727 153.342 214.147 154.867 213.289 156.235C212.431 157.604 211.311 158.789 209.994 159.723C208.677 160.657 207.189 161.322 205.615 161.678V161.678Z",
  fill: "url(#paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M277.113 146.375L134.021 177.077L141.284 210.924L284.376 180.222L277.113 146.375Z",
  fill: "#14D2A5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M198.198 128.456C194.234 129.307 190.611 131.315 187.788 134.224C184.964 137.134 183.067 140.816 182.336 144.804C181.605 148.792 182.073 152.907 183.681 156.629C185.288 160.351 187.964 163.513 191.368 165.714C194.773 167.916 198.754 169.059 202.808 168.998C206.862 168.937 210.806 167.675 214.143 165.372C217.48 163.07 220.06 159.829 221.555 156.061C223.05 152.292 223.394 148.165 222.544 144.2C221.979 141.568 220.902 139.072 219.372 136.857C217.843 134.641 215.893 132.748 213.632 131.286C211.371 129.824 208.845 128.821 206.196 128.336C203.548 127.851 200.83 127.891 198.198 128.456V128.456ZM204.98 160.091C202.692 160.582 200.309 160.383 198.134 159.52C195.959 158.657 194.089 157.169 192.759 155.242C191.43 153.316 190.702 151.039 190.667 148.699C190.632 146.359 191.292 144.062 192.563 142.097C193.834 140.132 195.659 138.588 197.808 137.66C199.956 136.732 202.331 136.463 204.633 136.885C206.935 137.307 209.06 138.403 210.739 140.033C212.418 141.663 213.576 143.754 214.067 146.043C214.724 149.11 214.136 152.314 212.432 154.948C210.728 157.583 208.048 159.433 204.98 160.091V160.091Z",
  fill: "#14D2A5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M509 191H189V633H509V191Z",
  fill: "#E0E0E0"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M503.498 198.094H194.272V625.342H503.498V198.094Z",
  fill: "url(#paint3_linear)"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M500 201H198V619H500V201Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M424 183H275V219H424V183Z",
  fill: "url(#paint4_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M349 148C337.404 148 328 157.624 328 169.5C328 181.376 337.404 191 349 191C360.596 191 370 181.376 370 169.5C370 157.624 360.596 148 349 148ZM349 181.906C346.535 181.964 344.108 181.286 342.029 179.959C339.951 178.632 338.315 176.716 337.331 174.455C336.347 172.194 336.059 169.691 336.504 167.265C336.948 164.84 338.106 162.602 339.829 160.837C341.551 159.073 343.761 157.862 346.175 157.359C348.589 156.856 351.099 157.084 353.383 158.013C355.667 158.943 357.622 160.532 358.998 162.578C360.375 164.624 361.111 167.034 361.111 169.5C361.135 172.741 359.874 175.86 357.604 178.173C355.335 180.487 352.241 181.808 349 181.847V181.906Z",
  fill: "url(#paint5_linear)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M422 182H276V216H422V182Z",
  fill: "#14D2A5"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M349.5 148C345.445 148 341.482 149.202 338.111 151.455C334.74 153.707 332.112 156.909 330.56 160.655C329.009 164.401 328.603 168.523 329.394 172.499C330.185 176.476 332.137 180.129 335.004 182.996C337.871 185.863 341.524 187.815 345.501 188.606C349.477 189.397 353.599 188.991 357.345 187.44C361.091 185.888 364.293 183.26 366.545 179.889C368.798 176.518 370 172.555 370 168.5C370 163.063 367.84 157.849 363.996 154.004C360.151 150.16 354.937 148 349.5 148ZM349.5 180.332C347.162 180.329 344.877 179.633 342.934 178.333C340.991 177.032 339.476 175.185 338.582 173.024C337.688 170.864 337.454 168.487 337.91 166.194C338.366 163.9 339.491 161.793 341.143 160.139C342.796 158.485 344.901 157.357 347.194 156.898C349.487 156.439 351.864 156.67 354.026 157.562C356.187 158.453 358.036 159.965 359.339 161.907C360.642 163.848 361.341 166.132 361.346 168.471C361.345 170.025 361.038 171.564 360.442 173C359.846 174.435 358.973 175.739 357.873 176.837C356.773 177.935 355.467 178.806 354.031 179.399C352.594 179.993 351.054 180.297 349.5 180.295V180.332Z",
  fill: "#14D2A5"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M13.9362 644.763H11.1826V660.384H13.9362V644.763Z",
  fill: "#47E6B1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M20.3733 653.954V651.2H4.75275V653.954H20.3733Z",
  fill: "#47E6B1"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M333.393 105H330.639V120.621H333.393V105Z",
  fill: "#47E6B1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M339.83 114.183V111.43H324.209V114.183H339.83Z",
  fill: "#47E6B1"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M564.939 671.1C564.136 670.777 563.489 670.193 563.122 669.458C562.754 668.724 562.693 667.89 562.948 667.116C562.989 666.998 563.015 666.876 563.025 666.752V666.752C563.049 666.397 562.948 666.046 562.737 665.749C562.527 665.451 562.219 665.225 561.858 665.102C561.497 664.979 561.103 664.967 560.734 665.067C560.366 665.167 560.041 665.374 559.81 665.657V665.657C559.729 665.757 559.662 665.865 559.608 665.979C559.259 666.721 558.626 667.318 557.83 667.657C557.034 667.996 556.131 668.053 555.293 667.817C555.164 667.779 555.032 667.755 554.897 667.746V667.746C554.514 667.724 554.133 667.818 553.811 668.012C553.489 668.206 553.243 668.49 553.111 668.823C552.978 669.156 552.964 669.52 553.073 669.86C553.181 670.201 553.405 670.5 553.712 670.714V670.714C553.82 670.788 553.937 670.851 554.061 670.9C554.864 671.223 555.511 671.807 555.878 672.542C556.246 673.276 556.307 674.11 556.052 674.884C556.011 675.002 555.985 675.125 555.975 675.248V675.248C555.951 675.603 556.052 675.954 556.263 676.251C556.473 676.549 556.781 676.775 557.142 676.898C557.503 677.021 557.897 677.033 558.266 676.933C558.634 676.833 558.959 676.626 559.19 676.343V676.343C559.271 676.243 559.338 676.135 559.392 676.021C559.741 675.279 560.374 674.682 561.17 674.343C561.966 674.004 562.869 673.947 563.707 674.183C563.836 674.221 563.968 674.245 564.102 674.254C564.486 674.276 564.867 674.182 565.189 673.988C565.511 673.794 565.757 673.51 565.889 673.177C566.022 672.844 566.036 672.48 565.927 672.14C565.819 671.799 565.595 671.5 565.288 671.286V671.286C565.18 671.212 565.063 671.149 564.939 671.1V671.1Z",
  fill: "#4D8AF0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M100.021 520.609C99.2791 520.259 98.682 519.626 98.343 518.83C98.0041 518.034 97.9471 517.131 98.1828 516.293C98.2208 516.164 98.2448 516.032 98.2543 515.898V515.898C98.2756 515.514 98.1824 515.133 97.9883 514.811C97.7942 514.489 97.5096 514.243 97.1766 514.111C96.8437 513.978 96.48 513.964 96.1395 514.073C95.799 514.181 95.4998 514.405 95.2861 514.712V514.712C95.2117 514.82 95.1493 514.937 95.1001 515.061C94.7772 515.864 94.1929 516.511 93.4583 516.878C92.7237 517.246 91.8902 517.307 91.1163 517.052C90.998 517.011 90.8755 516.985 90.7515 516.975V516.975C90.3973 516.951 90.0456 517.052 89.7486 517.263C89.4515 517.473 89.2247 517.781 89.102 518.142C88.9792 518.503 88.967 518.897 89.067 519.266C89.167 519.634 89.3739 519.959 89.6572 520.19V520.19C89.7569 520.271 89.8649 520.338 89.9791 520.392C90.7209 520.741 91.318 521.374 91.657 522.17C91.9959 522.966 92.0529 523.869 91.8172 524.707C91.7792 524.836 91.7552 524.968 91.7457 525.103C91.7244 525.486 91.8176 525.867 92.0117 526.189C92.2058 526.511 92.4904 526.757 92.8234 526.889C93.1564 527.022 93.52 527.036 93.8605 526.927C94.201 526.819 94.5002 526.595 94.7139 526.288V526.288C94.7883 526.18 94.8507 526.063 94.8999 525.939C95.2228 525.136 95.8071 524.489 96.5417 524.122C97.2763 523.754 98.1098 523.693 98.8837 523.948C99.0021 523.989 99.1245 524.015 99.2485 524.025C99.6027 524.049 99.9544 523.948 100.251 523.737C100.549 523.527 100.775 523.219 100.898 522.858C101.021 522.497 101.033 522.103 100.933 521.734C100.833 521.366 100.626 521.041 100.343 520.81V520.81C100.243 520.729 100.135 520.662 100.021 520.609Z",
  fill: "#FDD835"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M487.021 155.1C486.279 154.777 485.682 154.193 485.343 153.458C485.004 152.724 484.947 151.89 485.183 151.116C485.221 150.998 485.245 150.876 485.254 150.752C485.276 150.397 485.182 150.046 484.988 149.749C484.794 149.451 484.51 149.225 484.177 149.102C483.844 148.979 483.48 148.967 483.14 149.067C482.799 149.167 482.5 149.374 482.286 149.657V149.657C482.212 149.757 482.149 149.865 482.1 149.979C481.777 150.721 481.193 151.318 480.458 151.657C479.724 151.996 478.89 152.053 478.116 151.817C477.998 151.779 477.875 151.755 477.752 151.746V151.746C477.397 151.724 477.046 151.818 476.749 152.012C476.451 152.206 476.225 152.49 476.102 152.823C475.979 153.156 475.967 153.52 476.067 153.86C476.167 154.201 476.374 154.5 476.657 154.714V154.714C476.757 154.788 476.865 154.851 476.979 154.9C477.721 155.223 478.318 155.807 478.657 156.542C478.996 157.276 479.053 158.11 478.817 158.884C478.779 159.002 478.755 159.124 478.746 159.248V159.248C478.724 159.603 478.818 159.954 479.012 160.251C479.206 160.549 479.49 160.775 479.823 160.898C480.156 161.021 480.52 161.033 480.86 160.933C481.201 160.833 481.5 160.626 481.714 160.343V160.343C481.788 160.243 481.851 160.135 481.9 160.021C482.223 159.279 482.807 158.682 483.542 158.343C484.276 158.004 485.11 157.947 485.884 158.183C486.002 158.221 486.124 158.245 486.248 158.254C486.603 158.276 486.954 158.182 487.251 157.988C487.549 157.794 487.775 157.51 487.898 157.177C488.021 156.844 488.033 156.48 487.933 156.14C487.833 155.799 487.626 155.5 487.343 155.286V155.286C487.243 155.212 487.135 155.149 487.021 155.1V155.1Z",
  fill: "#FDD835"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M595.5 341C598.538 341 601 338.538 601 335.5C601 332.462 598.538 330 595.5 330C592.462 330 590 332.462 590 335.5C590 338.538 592.462 341 595.5 341Z",
  fill: "#F55F44"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M168.5 657C171.538 657 174 654.538 174 651.5C174 648.462 171.538 646 168.5 646C165.462 646 163 648.462 163 651.5C163 654.538 165.462 657 168.5 657Z",
  fill: "#F55F44"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M538.5 460C541.538 460 544 457.538 544 454.5C544 451.462 541.538 449 538.5 449C535.462 449 533 451.462 533 454.5C533 457.538 535.462 460 538.5 460Z",
  fill: "#F55F44"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M63.5 181C66.5376 181 69 178.538 69 175.5C69 172.462 66.5376 170 63.5 170C60.4624 170 58 172.462 58 175.5C58 178.538 60.4624 181 63.5 181Z",
  fill: "#4D8AF0"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M5.5 332C8.53757 332 11 329.314 11 326C11 322.686 8.53757 320 5.5 320C2.46243 320 0 322.686 0 326C0 329.314 2.46243 332 5.5 332Z",
  fill: "#47E6B1"
});

var _ref25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 298.279,
  y1: 595.703,
  x2: 208.647,
  y2: 177.963,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 80414.3,
  y1: -10366.5,
  x2: 80038.7,
  y2: -12117.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 23577.8,
  y1: 1305.87,
  x2: 23049.9,
  y2: -1150.38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 147509,
  y1: 303771,
  x2: 147509,
  y2: 54509.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 71339.1,
  y1: 5803.68,
  x2: 71339.1,
  y2: 4023.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 28336.1,
  y1: 7732.77,
  x2: 28336.1,
  y2: 5219.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})));

function SvgNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 781,
    viewBox: "0 0 601 781",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.d5cc8af9.svg";
export { ForwardRef as ReactComponent };